export const blockTypes = [
  { style: 'blockquote', iconName: 'quote right' },
  { style: 'unordered-list-item', iconName: 'list ul' },
  { style: 'ordered-list-item', iconName: 'list ol' }
];



// WEBPACK FOOTER //
// ./src/component/TextEditor/blockTypes.js